(() => {
  const initialize = (scope = document) => {
    const roots = scope.matches?.('[data-phox-news]')
      ? [scope]
      : scope.querySelectorAll('[data-phox-news]');

    roots.forEach((root) => {
      if (root.dataset.newsReady === 'true') return;
      const feed = root.querySelector('[data-news-feed]');
      if (!feed) return;
      const filters = feed.querySelector('[data-news-filters]');
      const count = feed.querySelector('[data-news-count]');
      if (!filters || !count) return;

      const cards = Array.from(feed.querySelectorAll('[data-news-card]')).map((element) => {
        let tags = [];
        try {
          const parsed = JSON.parse(element.dataset.tags || '[]');
          if (Array.isArray(parsed)) tags = parsed.filter((tag) => typeof tag === 'string');
        } catch {
          tags = [];
        }
        return { element, tags };
      });
      const categories = Array.from(new Set(cards.flatMap((card) => card.tags)))
        .sort((first, second) => first.localeCompare(second));

      categories.forEach((category) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pn-filter';
        button.dataset.newsFilter = category;
        button.setAttribute('aria-pressed', 'false');
        button.textContent = category;
        filters.append(button);
      });

      filters.addEventListener('click', (event) => {
        const selected = event.target.closest('[data-news-filter]');
        if (!selected || !filters.contains(selected)) return;
        const category = selected.dataset.newsFilter;
        let visible = 0;
        cards.forEach(({ element, tags }) => {
          const show = !category || tags.includes(category);
          element.hidden = !show;
          if (show) visible += 1;
        });
        filters.querySelectorAll('[data-news-filter]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button === selected));
        });
        count.textContent = `${visible} ${visible === 1 ? count.dataset.singular : count.dataset.plural}`;
      });

      filters.hidden = categories.length === 0;
      root.dataset.newsReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
